<template>
    <div class="AdminEntityItemCreate">
        <FadeTransition mode="out-in">
            <div class="AdminEntityItemHeader flex row-stretch-center">
                <Breadcrumbs :breadcrumbs="breadcrumbs" />
                <div v-if="buttons">
                    <WButton
                        v-for="({ text, disabled, onClick, ...otherProps }, index) in buttons"
                        :key="index"
                        :disabled="disabled"
                        v-bind="otherProps"
                        class="ml-1"
                        @click="onClick"
                    >
                        {{ text }}
                    </WButton>
                </div>
            </div>
        </FadeTransition>

        <WCard :loading="isLoading">
            <EntityItemForm
                v-model="row"
                :columns="columns"
                :selectGroups="selectGroups"
                :entityKey="entityKey"
            />
        </WCard>
    </div>
</template>
<script>
import {
    Api, apiRequest, rethrowError, notifySuccess, notifyHttpError,
} from '@/api'
import { Breadcrumbs } from '@/components'
import { EntityItemForm } from '../components'

export default {
    name: 'AdminEntityItemCreate',
    components: {
        Breadcrumbs,
        EntityItemForm,
    },
    metaInfo () {
        return {
            title: this.$t(`admin.navigation.entities.${this.entityKey}`),
        }
    },
    data () {
        return {
            row: undefined,
            columns: undefined,
            selectGroups: undefined,
            isLoading: false,
        }
    },
    computed: {
        breadcrumbs () {
            return [{
                key: this.entityKey,
                label: this.$t(`admin.navigation.entities.${this.entityKey}`),
                to: { name: 'AdminEntityList', params: { entityKey: this.entityKey } },
            }, {
                key: 'entity-detail',
                label: this.$t('entities.actions.createRow'),
            }]
        },
        buttons () {
            return [{
                iconLeft: 'save',
                text: this.$t('entities.actions.save'),
                loading: this.isLoading,
                disabled: this.isLoading,
                onClick: this.addRow,
            }]
        },
    },
    beforeCreate () {
        const { entityKey } = this.$route.params
        this.entityKey = entityKey
    },
    mounted () {
        this.getData()
    },
    methods: {
        async getData () {
            this.isLoading = true
            apiRequest(Api().outputs.get({ entityKey: this.entityKey, params: { id: '-1' } }))
                .then(({ data }) => {
                    const { selectGroups, columns, rows } = data || {}
                    const [row] = rows || []
                    this.row = row
                    this.selectGroups = selectGroups
                    this.columns = columns
                })
                .catch((error) => {
                    this.$router.back()
                    rethrowError(notifyHttpError())(error)
                })
                .finally(() => (this.isLoading = false))
        },
        async addRow () {
            this.isLoading = true
            const params = { type: this.entityKey, row: this.row }
            apiRequest(Api().imports.create(params))
                .then(({ data }) => {
                    notifySuccess(this.$t('entities.modals.editSuccess'))()
                    this.$router.push({ name: 'AdminEntityList', params: { entityKey: this.entityKey } })
                })
                .catch(rethrowError(notifyHttpError()))
                .finally(() => (this.isLoading = false))
        },
    },
}
</script>
<style lang="scss" scoped>
.AdminEntityItemHeader {
    margin-bottom: 20px;
}

.WCard {
	@include admin-screen-height(54px);
}
</style>
